// 🚫 首先初始化弃用警告屏蔽器 - 必须在所有其他导入之前
import { initDeprecationSuppressor } from './utils/deprecationSuppressor'
initDeprecationSuppressor()

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 富文本编辑器
import VueQuillEditor, { Quill } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// 扩展字体大小功能
const Size = Quill.import('attributors/style/size')
Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px', '24px', '32px']
Quill.register(Size, true)

Vue.use(ElementUI)
Vue.use(VueQuillEditor)

Vue.config.productionTip = false

// 在开发环境下测试弃用警告屏蔽效果
if (process.env.NODE_ENV === 'development') {
  import('./utils/warningTest.js')
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
